export default class BaseConfig {
  public url: string = ''
}
